(ns hypnos.backoffice.tile.recommendations
  "Recommendations tile."
  (:require [hypnos.backoffice.core.auth :as auth]
            [hypnos.backoffice.subs]
            [hypnos.backoffice.tile.field.consult-recommendations-note :as consult-recommendations-note]
            [hypnos.backoffice.tile.table.recommendation :as recommendation]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [hypnos.translator.patient :as t-p]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Healpers

(defn- load
  [body]
  (if-let [_loading? @(rf/subscribe [:backoffice/gql-request-in-progress?])]
    [:div.card-content
     [:section.section
      [:div.content.has-text-grey.has-text-centered
       [:p
        [:span.icon.is-large
         [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
       [:p (tr :ui.label/loading)]]]]
    body))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Tile

(defn tile
  [state]
  (let [auth    (rf/subscribe [:backoffice/auth])
        patient (rf/subscribe [:backoffice/patient])]
    [:div.tile.is-ancestor
     [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/recommendations)]
        (when (auth/authorized? @auth :make-recommendation)
          [:button.button.is-info
           {:disabled (nil? (get-in @state [:recommendations :system 0 :recommendation/confidence-min]))
            :on-click (fn [_]
                        ;; submit information
                        (rf/dispatch-sync [:amplify/mutation
                                           mutations/recommend-masks
                                           {:consult         (t-p/consult->gql (dissoc (:patient/last-consult @patient)
                                                                                       :consult/key
                                                                                       :consult/user
                                                                                       :consult/recorded-at
                                                                                       :consult/recommendations
                                                                                       :consult/recommendations-note))
                                            :recommendations (->> (get-in @state [:recommendations :system])
                                                                  (mapv t-p/recommendation->db)
                                                                  (mapv t-p/recommendation->gql)
                                                                  (remove nil?))
                                            :note            (get-in @state [:recommendations :note])}
                                           :backoffice/refresh-consults
                                           :backoffice/noop]))}
           [:span (tr :ui.label/submit)]])]
       (load
        [:div.card-content
         [recommendation/recommendation-table state]
         [consult-recommendations-note/field state]])]]]))
